<template>
  <div>
    <Menu />
    <div id="teste-pezinho" class="container main">
      <div class="row">
        <div class="col-md-12">
          <SectionTitle
            title="Teste do pezinho"
            description="Gestantes a parir por mês."
            url="/saude-crianca"
          />
        </div>
        <div class="col-md-12">
          <selects
            :callbackOnChangeEquipe="onChangeEquipe"
            :callbackOnChangeProfissional="onChangeProfissional"
            :activeSelectMicroArea="true"
            :callbackOnChangeMicroArea="onChangeMicroArea"
          ></selects>
        </div>
        <div class="col-md-12">
          <b-tabs fill class="esus-feedback-tabs" v-model="tabsActive">
            <b-tab title="Lista" active @click="buscarDadosDaLista()">
              <template v-slot:title>
                <i class="icofont-list"></i> Lista
              </template>
              <div class="row">
                <div class="full-table">
                  <div class="col-md-12">
                    <div class="info-table">
                      <div class="select-situacao info-table-item">
                        <vue-select
                          :options="mesDPPOptions"
                          label="label"
                          placeholder="Mês da DPP"
                          v-model="mesDPP"
                          @input="handleMesDPP()"
                          :clearable="true"
                        >
                          <template slot="option" slot-scope="option">
                            {{ option.label }}
                          </template>
                          <div slot="no-options">
                            Não há opções correspondentes
                          </div>
                        </vue-select>
                      </div>
                      <div class="info-table-item">
                        <download-files
                          :callback-pdf="generatePdf"
                          :data="displayedCadastros"
                          :fields="dataFields"
                          name="teste-pezinho"
                        >
                        </download-files>
                      </div>
                    </div>
                    <tabela-cadastros
                      ref="table"
                      :cadastros="displayedCadastros"
                      :loading="loadingLista"
                      @filterSearch="filterSearch($event)"
                    ></tabela-cadastros>
                  </div>
                </div>
              </div>
            </b-tab>
          </b-tabs>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Menu from '@/components/Menu'
import Footer from '@/components/Footer'
import Loader from '@/components/Loader'
import SectionTitle from '@/components/SectionTitle'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import * as Functions from './functions'
import TabelaCadastros from './TabelaCadastros.vue'
import utils from '@/mixins/utils.js'
import TitleTag from '@/components/TitleTag.vue'
import DownloadFiles from '@/components/utils/DownloadFiles.vue'
import { dataFields } from './utils.js'
import Selects from '@/components/utils/Selects.vue'

export default {
  name: 'TestePezinho',
  metaInfo: {
    title: 'Teste do pezinho',
    titleTemplate: null,
  },
  components: {
    Menu,
    Footer,
    PulseLoader,
    Loader,
    SectionTitle,
    TabelaCadastros,
    TitleTag,
    DownloadFiles,
    Selects,
  },
  mixins: [utils],
  data() {
    return {
      equipe: '',
      profissionais: [],
      profissional: '',
      dados: [],
      cadastros: [],
      loadingLista: false,
      tabsActive: 0,
      exibirCadastrosVermelhos: false,
      exibirCadastrosVerdes: false,
      micro_area: '',
      mesDPPOptions: [],
      mesDPP: '',
      setRed: false,
      dataFields: { ...dataFields },
      filterSearchTable: false,
    }
  },
  computed: {
    displayedCadastros() {
      if (this.filterSearchTable != false) {
        return this.filterSearchTable
      }
      return this.cadastros
    },
  },
  methods: {
    filterSearch(item) {
      if (item.filter !== false) {
        this.filterSearchTable = item.filter
        return
      }
      this.filterSearchTable = false
    },

    handleMesDPP() {
      if (this.mesDPP.value === 'TODOS') {
        this.cadastros = this.dados
      } else {
        this.cadastros = this.dados.filter(
          (item) => item.mes_dpp == this.mesDPP.value
        )
      }
    },

    async onChangeEquipe(event) {
      if (this.$refs.table) {
        this.$refs.table.search = ''
      }
      if (event !== null) {
        this.loadingLista = true
        this.situacao = ''
        this.tabsActive = 0
        this.profissionais = []
        this.cadastros = []
        this.equipe = event
        this.mesDPP = null
        try {
          const response2 = await this.$api.get(
            '/app/teste-pezinho/' +
              this.$store.state.cod_ibge +
              '/equipe/' +
              this.equipe.nu_ine
          )
          this.dados = response2.data
          this.cadastros = response2.data
        } catch (error) {
          console.log(error)
        } finally {
          this.loadingLista = false
        }
      } else {
        this.cadastros = []
      }
    },

    onChangeProfissional(event) {
      if (this.$refs.table) {
        this.$refs.table.search = ''
      }
      if (event == null) {
        this.cadastros = []
        return
      }
      this.profissional = event
      this.mesDPP = null
      this.tabsActive = 0
      this.buscarDadosDaLista()
    },

    async onChangeMicroArea(event) {
      if (this.$refs.table) {
        this.$refs.table.search = ''
      }
      if (event == null) {
        this.cadastros = []
        return
      }
      try {
        this.mesDPP = null
        this.loadingLista = true
        this.profissional = null
        this.micro_area = event?.micro_area
        if (this.micro_area == undefined) {
          this.tabsActive = 0
        }
        if (this.micro_area !== undefined) {
          const response = await this.$api.get(
            '/app/teste-pezinho/' +
              this.$store.state.cod_ibge +
              '/micro-area/' +
              this.equipe.nu_ine +
              '/' +
              this.micro_area
          )
          if (response) {
            this.dados = response.data
            this.cadastros = response.data
          }
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loadingLista = false
      }
    },

    async buscarDadosDaLista() {
      if (this.profissional !== '' && this.profissional !== null) {
        this.loadingLista = true
        try {
          let response = await this.$api.get(
            '/app/teste-pezinho/' +
              this.$store.state.cod_ibge +
              '/acs/' +
              this.profissional.nu_cpf
          )
          if (response) {
            this.dados = response.data
            this.cadastros = response.data
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.loadingLista = false
        }
      }
    },

    generatePdf() {
      Functions.generatePdf(
        this.displayedCadastros,
        this.equipe,
        this.profissional
      )
    },

    async buscarDadosIniciais() {
      try {
        const response = await this.$api.get(
          '/app/teste-pezinho/' + this.$store.state.cod_ibge
        )
        if (response) {
          this.dados = response.data
          this.cadastros = response.data

          response.data.forEach((item) => {
            this.mesDPPOptions.push({
              label: item.mes_dpp,
              value: item.mes_dpp,
            })
          })

          this.mesDPPOptions.push({ label: 'TODOS', value: 'TODOS' })

          // removendo valores duplicados
          this.mesDPPOptions = this.mesDPPOptions
            .map((e) => JSON.stringify(e))
            .reduce((acc, cur) => (acc.includes(cur) || acc.push(cur), acc), [])
            .map((e) => JSON.parse(e))

          // ordenando
          this.mesDPPOptions = this.mesDPPOptions.sort(function (a, b) {
            let dateA = new Date(a.value.split('/')[1], a.value.split('/')[0])
            let dateB = new Date(b.value.split('/')[1], b.value.split('/')[0])
            if (dateA > dateB) return 1
            if (dateA < dateB) return -1
            return 0
          })
        }
      } catch (error) {
        console.log(error)
      }
    },

    init() {
      this.buscarDadosIniciais()
    },
  },
  created() {
    this.init()
  },
}
</script>

<style>
#teste-pezinho .select-situacao .vs__dropdown-menu {
  border-top-left-radius: 0px;
  border-top-right-radius: 0px;
  padding: 0px;
}
#teste-pezinho .select-situacao .vs--searchable .vs__dropdown-toggle {
  padding: 5px;
}
#teste-pezinho .select-situacao .v-select {
  width: 296px;
}
#teste-pezinho .select-situacao .vs__dropdown-toggle {
  background-color: #fff;
}
</style>
